import React, { Component, Fragment } from 'react'
import './Carousel.scss'

class CarouselIndicators extends Component {
  render() {
    let { currentSlide, totalSlides, className } = this.props

    const indicators = totalSlides.map((slide, index) => {
      const isCurrentSlide = currentSlide === index ? 'active' : ''
      return (
        <li key={index} className={isCurrentSlide} onClick={() => this.props.goToIndex(index)} />
      )
    })

    return (
      <Fragment>
        <div className="carousel slide">
          <ol className={`carousel-indicators ${className}`}>{indicators}</ol>
        </div>
      </Fragment>
    )
  }
}

export default CarouselIndicators
